import { render, staticRenderFns } from "./HotQuestion.vue?vue&type=template&id=70f06c99&scoped=true&"
import script from "./HotQuestion.vue?vue&type=script&lang=js&"
export * from "./HotQuestion.vue?vue&type=script&lang=js&"
import style0 from "./HotQuestion.vue?vue&type=style&index=0&id=70f06c99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f06c99",
  null
  
)

export default component.exports